import React from "react";
import { useFormContext } from 'react-hook-form';
import { useCreditCardValidator } from 'react-creditcard-validator';
import { CardPlaceholder, VisaSvg, MastercardSvg, AmexSvg } from "./Svg.js";

const CardInput = () => {
    const { setValue } = useFormContext();
    const {
        getCardNumberProps,
        getExpiryDateProps,
        getCVCProps,
        getCardImageProps,
        meta: { erroredInputs }
      } = useCreditCardValidator();

    const customSvg = {
        'placeholder': <CardPlaceholder />,
        'visa': <VisaSvg />,
        'mastercard': <MastercardSvg />,
        'amex': <AmexSvg />
    }

    const expiryFormat = (value) => {
        setValue('exp_month', parseInt(value.replace(/\s|\//g, '').substring(0, 2)));
        setValue('exp_year', parseInt(value.replace(/\s|\//g, '').substring(2, 4)))
    }


    return (
        <div className={`input-container container-fluid card-input mb-4 px-0`}>
            <div className="row">
                <div className="creditcard-input-container col-md-6 col-12">
                    <label className="form-label" htmlFor="number_field">Kortanúmer</label>
                    <div className="align-items-center">
                    <div className="creditcard-img float-end" {...getCardImageProps({ images: customSvg })} />
                    </div>
                    <input className="form-control position-relative" {...getCardNumberProps({ onChange: (e) => setValue('number', e.target.value) })} />
                    <small className="error-msg">{erroredInputs.cardNumber && 'Kortanúmer er ekki gilt'}</small>
                </div>
                <div className="col-md-3 col-12">
                    <label className="form-label" htmlFor="expire_field"  >Gildistími</label>
                    <input className="expiry form-control" {...getExpiryDateProps({ onChange: (e) => expiryFormat(e.target.value) })} />
                    <small className="error-msg">{erroredInputs.expiryDate && 'Villa í dagsetningu'}</small>
                </div>
                <div className="col-md-3 col-12">
                    <label className="form-label" htmlFor="cvc_field">CVC númer</label>
                    <input className="expiry form-control" {...getCVCProps({ onChange: (e) => setValue('cvc', e.target.value) })} />
                    <small className="error-msg">{erroredInputs.cvc && 'Villa í CVC'}</small>
                </div>
            </div>
        </div>
    )
}

export default CardInput;